
const EmptyProfileIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12Z" fill="#EBEDF4" stroke="white" />
            <path d="M12.1002 13.5039C10.1437 13.5039 8.47266 13.8124 8.47266 15.0462C8.47266 16.2804 10.1333 16.5998 12.1002 16.5998C14.0566 16.5998 15.7277 16.2918 15.7277 15.0575C15.7277 13.8232 14.0675 13.5039 12.1002 13.5039Z" fill="#393E46" />
            <path opacity="0.4" d="M12.0997 12.3293C13.4324 12.3293 14.5002 11.2611 14.5002 9.92882C14.5002 8.59657 13.4324 7.52832 12.0997 7.52832C10.7675 7.52832 9.69922 8.59657 9.69922 9.92882C9.69922 11.2611 10.7675 12.3293 12.0997 12.3293Z" fill="#393E46" />
        </svg>
    )
}

export default EmptyProfileIcon;